<template>
  <transition name="fade">
    <div v-show="tuPopuBoHidden" class="tui-confirm-box app-z-3">
      <div class="tui-confirm-modal"></div>
      <div class="tui-confirm-content" :class="{'tui-confirm-content-show':tuPopuBoHidden}">
        <div class="tui-confirm-header app-main-color"></div>
        <div class="tui-confirm-body">
          <slot></slot>
        </div>
        <div class="tui-confirm-footer">
          <div
            class="tui-confirm-buttom tui-confirm-buttom-main"
            @mousedown="onConfirm()"
          >{{confirmText}}</div>
          <div
            class="tui-confirm-buttom tui-confirm-buttom-secondary"
            @mousedown="onCancel()"
          >{{cancelText}}</div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean
    },
    "confirm-text": {
      type: String,
      default: "确认"
    },
    "cancel-text": {
      type: String,
      default: "取消"
    }
  },
  data() {
    return {
      tuPopuBoHidden: this.value
    };
  },
  watch: {
    value(val) {
      this.tuPopuBoHidden = val;
    },
    tuPopuBoHidden(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    //点击主按钮
    onConfirm() {
      this.$emit("on-confirm");
      this.tuPopuBoHidden = false;
    },
    //点击副按钮
    onCancel() {
      this.$emit("on-cancel");
      this.tuPopuBoHidden = false;
    }
  }
};
</script>
<style>
.tui-confirm-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0px;
  left: 0px;
  display: flex;
  z-index: 2;
  justify-content: center;
  align-items: center;
}
.tui-confirm-modal {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.44);
  z-index: -1;
}
.tui-confirm-content {
  width: 80vw;
  border-radius: 2px;
  box-shadow: 0 0 5px 1px rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.9);
  transition: 0.2s;
}
.tui-confirm-header {
  height: 5px;
  border-radius: 2px 2px 0 0;
}
.tui-confirm-body {
  font-size: 1.5rem;
  padding: 5vw 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tui-confirm-footer {
  display: flex;
  justify-content: flex-end;
}
.tui-confirm-buttom {
  padding: 10px 20px 15px 25px;
  font-size: 15px;
}
.tui-confirm-buttom-main {
  color:#5a99ff;
}
.tui-confirm-buttom-secondary {
  color: #5a99ff;
}
/*过渡动画*/
.fade-enter-active,
.fade-leave-active {
  transition: 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/container/confirm.vue